import React, { useState } from 'react';
import { T, t, lang as langNavigator } from '../../../helpers/i18n';
import { ToggleSelectLabeled } from '../../../components/ToggleSelectLabeled';
// import Tag from '../../Tags/Tag'
import theme from '../../../Theme';
import { LabelInput } from '../../../components/LabelInput';
import { inject } from 'mobx-react';
export var Tags = inject('store')(function (props) {
    var hrefValue = props.hrefValue, destinationValue = props.destinationValue, categoryValue = props.categoryValue, tagValue = props.tagValue, tags = props.tags, language = props.language, destinations = props.destinations, categories = props.categories, style = props.style, onChange = props.onChange;
    var mainTagValue = tags[language] ? tags[language]['mainTag'] || '' : '';
    var languageDetected = langNavigator;
    var handleChange = function (_a) {
        var val = _a.val, field = _a.field, lang = _a.lang, multiple = _a.multiple, selectedArray = _a.selectedArray;
        var selected = [];
        val.target.options.forEach(function (option) {
            if (option.selected) {
                selected.push(option.value);
            }
        });
        if (!multiple && selectedArray[0]) {
            if (selectedArray[0] === selected[0]) {
                // quiero deseleccionar
                selected.splice(0);
            }
        }
        switch (field) {
            case 'destination':
                setDestinationSelectedArray(selected);
                break;
            case 'category':
                setCategorySelectedArray(selected);
                break;
            case 'tag':
                setTagSelectedArray(selected);
                break;
            default:
                break;
        }
        onChange({ value: multiple ? selected : selected[0], field: field, lang: lang });
    };
    var handleChangeSearch = function (_a) {
        var field = _a.field, value = _a.value;
        switch (field) {
            case 'destination':
                setDestinationSearch(value);
                break;
            case 'category':
                setCategorySearch(value);
                break;
            case 'tag':
                setTagSearch(value);
                break;
            default:
        }
    };
    /********          href     ********/
    var _a = useState(hrefValue), href = _a[0], setHref = _a[1];
    /********                   ********/
    /********    DESTINATION         ************/
    var isDestinationMultiple = false;
    var _b = useState(destinationValue ? [destinationValue] : []), destinationSelectedArray = _b[0], setDestinationSelectedArray = _b[1];
    var _c = useState(''), destinationSearch = _c[0], setDestinationSearch = _c[1];
    var _destinations = destinations || [];
    if (destinationSearch) {
        _destinations = destinations.filter(function (d) { return d.name.toLowerCase().includes(destinationSearch.toLowerCase()); });
    }
    var destinationsOptions = _destinations.map(function (destination) { return ({
        id: destination.id,
        name: destination.name,
        value: destination.id,
        selected: !!destinationSelectedArray.find(function (dsa) { return dsa === destination.id; })
    }); });
    /********                 ************/
    /********    CATEGORIES         ************/
    var isCategoryMultiple = true;
    var maxCategorySelectable = 2;
    var _d = useState(categoryValue || []), categorySelectedArray = _d[0], setCategorySelectedArray = _d[1];
    var _e = useState(''), categorySearch = _e[0], setCategorySearch = _e[1];
    var _categories = categories || [];
    if (categorySearch) {
        _categories = categories.filter(function (c) {
            var _a, _b;
            return languageDetected && ((_a = c.value) === null || _a === void 0 ? void 0 : _a[languageDetected]) ?
                (_b = c.value) === null || _b === void 0 ? void 0 : _b[languageDetected].toLowerCase().includes(categorySearch.toLowerCase()) :
                c.name.toLowerCase().includes(categorySearch.toLowerCase());
        });
    }
    var categoryOptions = _categories.map(function (category) {
        var _a;
        return ({
            id: category.id,
            name: ((_a = category.value) === null || _a === void 0 ? void 0 : _a[languageDetected]) || category.name,
            value: category.id,
            selected: !!categorySelectedArray.find(function (dsa) { return dsa === category.id; })
        });
    });
    /********                 ************/
    /********    TAGS         ************/
    var isTagMultiple = true;
    var _f = useState(tagValue || []), tagSelectedArray = _f[0], setTagSelectedArray = _f[1];
    var _g = useState(''), tagSearch = _g[0], setTagSearch = _g[1];
    var _tags = tags || [];
    if (tagSearch) {
        _tags = tags.filter(function (item) {
            var _a;
            return languageDetected && ((_a = item.value) === null || _a === void 0 ? void 0 : _a[languageDetected]) ?
                item.value[languageDetected].toLowerCase().includes(tagSearch.toLowerCase()) :
                item.name.toLowerCase().includes(tagSearch.toLowerCase());
        });
    }
    var tagOptions = _tags.map(function (tag) {
        var _a;
        return ({
            id: tag.id,
            name: ((_a = tag.value) === null || _a === void 0 ? void 0 : _a[languageDetected]) || tag.name,
            value: tag.id,
            selected: !!tagSelectedArray.find(function (tsa) { return tsa === tag.id; })
        });
    });
    /** *****                     ****** */
    return React.createElement("div", { style: style },
        React.createElement(LabelInput, { name: T('href'), value: href, onChange: function (e) {
                var value = e.target.value;
                setHref(value);
                onChange({ value: value, field: 'href', lang: language });
            } }),
        React.createElement(ToggleSelectLabeled, { name: t('destination'), field: 'destination', value: destinationValue, options: destinationsOptions, multiple: isDestinationMultiple, onChange: function (val) {
                handleChange({ val: val, field: 'destination', lang: language, multiple: isDestinationMultiple, selectedArray: destinationSelectedArray });
            }, language: language, onSearchChange: handleChangeSearch }),
        space(5),
        React.createElement(ToggleSelectLabeled, { name: t('category'), field: 'category', value: categoryValue, options: categoryOptions, multiple: isCategoryMultiple, maxSelected: maxCategorySelectable, onChange: function (val) {
                handleChange({ val: val, field: 'category', lang: language, multiple: isCategoryMultiple, selectedArray: categorySelectedArray });
            }, language: language, onSearchChange: handleChangeSearch, onMaxSelected: function () {
                props.store.UI.newWarning("".concat(T('max'), ". ").concat(maxCategorySelectable));
            } }),
        space(5),
        React.createElement(ToggleSelectLabeled, { name: t('tags'), field: 'tag', value: tagValue, options: tagOptions, multiple: isTagMultiple, onChange: function (val) {
                handleChange({ val: val, field: 'tag', lang: language, multiple: isTagMultiple, selectedArray: tagSelectedArray });
            }, language: language, onSearchChange: handleChangeSearch }));
});
var space = function (size) {
    if (size < 0 || size > 8)
        throw new Error('size no valido');
    return (React.createElement("div", { style: { height: theme.size.space[size], } }));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/Tags.tsx
// module id = 1516
// module chunks = 0